/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: dc7ab8ef8d2a
 */

import * as z from "zod";

export type TagsListResponse = {
  tags?: Array<string> | undefined;
  next_cursor?: string | null | undefined;
};

export const TagsListResponse$zodSchema: z.ZodType<TagsListResponse> = z.object(
  {
    next_cursor: z.string().nullable().optional(),
    tags: z.array(z.string()).optional(),
  },
);
